<template>
    <DModal
        v-model="comment"
        :show="showModal"
        :title="enabled
            ? __('customers.contracts.abuse_lock.confirm_title_enable')
            : __('customers.contracts.abuse_lock.confirm_title_disable')"
        :message="enabled
            ? __('customers.contracts.abuse_lock.confirm_message_enable')
            : __('customers.contracts.abuse_lock.confirm_message_disable')"
        is-confirm
        :is-awaiting-validation="true"
        :show-change-reason-input="true"
        is-error
        @update:show="$emit('update:showModal', $event)"
        @confirm="abuseLockConfirm"
        @close="$emit('close-modal')"
    />
</template>

<script>
export default {
    name: 'AbuseLockContractModal',
    props: {
        contract: {
            type: Object,
            default: () => { return {} }
        },
        showModal: {
            type: Boolean,
            default: false
        },
        enabled: {
            type: Boolean,
            default: false
        }
    },
    emits: ['close-modal', 'update:showModal'],
    data () {
        return {
            comment: ''
        }
    },
    methods: {
        abuseLockConfirm () {
            this.$inertia.post(this.$route('customers.customers.contracts.abuse-lock', {
                customer: this.contract.customer_id,
                contract: this.contract.id
            }),
            {
                enabled: this.enabled,
                activity_log_comment: this.comment
            },
            {
                onSuccess: () => {
                    this.comment = ''
                    this.$emit('close-modal')
                }
            })
        }
    }
}
</script>
